import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M24.36 9.11a1.4 1.4 0 0 0-1.22-.7H8.86a1.39 1.39 0 0 0-1.22.7 1.42 1.42 0 0 0 0 1.41l7.14 12.37a1.41 1.41 0 0 0 2.44 0l7.14-12.37a1.42 1.42 0 0 0 0-1.41z' })
));